@for (user of users; track user) {
  <div
    class="symbol symbol-35px symbol-circle"
    [ngbTooltip]="user.name"
    placement="top"
    >
    @if (user.avatar) {
      <img [src]="user.avatar" alt="Pic" />
    }
    @if (user.initials) {
      <span class="symbol-label bg-primary text-inverse-primary fw-bolder">
        {{ user.initials }}
      </span>
    }
  </div>
}
